import { Box, Button, Chip, CircularProgress, Grid, Modal, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import exportExcel from "utils/excelGenerate";
import { getProspectusVisitsDetails, getVisitsDetails } from '_controllers/officer';
import VisibilityIcon from '@mui/icons-material/Visibility';
import axios from 'axios';
import { PageHeader, SectionCard, EmptyState } from "_shared/ui";

const messageStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: "none",
    boxShadow: 24,
    pt: 2,
    pb: 0,
    pl: 4,
    pr: 4,
    textAlign: 'left',
    letterSpacing: 1
};

// Map a visit completion status to a theme semantic color for the status Chip.
const getStatusColor = (completed) => (completed ? "success" : "warning");

const ProspectusVisits = () => {
    const { SAP_ID } = useParams();
    const url = process.env.REACT_APP_REQUEST_ENDPOINT

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [visitDetails, setVisitDetails] = useState([])
    const [message, setMessage] = useState("");
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [csvData, setCsvData] = useState([]);
    const [prospectVisit, setProspectVisit] = useState(true)
    const [customerVisit, setCustomerVisit] = useState(false)
    const [customerVisitData, setCustomerVisitData] = useState([])
    const [influencerVisit, setInfluencerVisit] = useState(false)
    const [influencerVisitData, setInfluencerVisitData] = useState([])

    const [Values, setValues] = useState({
        selectStartDate: '',
        selectEndDate: '',
    });

    const { selectStartDate, selectEndDate } = Values

    const timeSpent = (a, b) => {
        const test = moment.duration(moment(b ? b : "").diff(moment(a ? a : "")))
        return `${test.asMinutes().toFixed(0)} mins`;
    };

    useEffect(async () => {
        const start = startDate
            ? startDate
            : moment().startOf("month").format("YYYY-MM-DD");

        const end = endDate
            ? endDate
            : moment().endOf("month").format("YYYY-MM-DD");
        const plan = await getProspectusVisitsDetails({
            SAP_ID,
            start,
            end,
        });
        console.log("gyp", plan?.data);
        setData(plan?.data);
        setCsvData(plan?.data)
        setLoading(true);
    }, [message, startDate, endDate]);

    const token = localStorage.getItem("token");
    const config = {
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    }


    useEffect(async () => {
        const start = selectStartDate
            ? selectStartDate
            : moment().startOf("month").format("YYYY-MM-DD");

        const end = selectEndDate
            ? selectEndDate
            : moment().endOf("month").format("YYYY-MM-DD");

        await axios.get(
            `${url}/api/v1/visit/customer/dash?userId=${SAP_ID}&endDate=${end ? end : ""}&startDate=${start ? start : ""
            }`,
            config
        ).then((res) => {
            console.log("res", res);
            setCustomerVisitData(res?.data?.data)
        }).catch((err) => {
            console.log("err", err);
            // setMessage(err?.message)
        });
    }, [message, selectStartDate, selectEndDate]);

    useEffect(async () => {
        const start = selectStartDate
            ? selectStartDate
            : moment().startOf("month").format("YYYY-MM-DD");

        const end = selectEndDate
            ? selectEndDate
            : moment().endOf("month").format("YYYY-MM-DD");

        await axios.get(
            `${url}/api/v1/visit/influencer/dash?userId=${SAP_ID}&endDate=${end ? end : ""}&startDate=${start ? start : ""
            }`,
            config
        ).then((res) => {
            console.log("res", res);
            setInfluencerVisitData(res?.data?.data)
        }).catch((err) => {
            console.log("err", err);
            // setMessage(err?.message)
        });
    }, [message, selectStartDate, selectEndDate]);

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (e) => {
        setValues({ ...Values, [e.target.name]: e.target.value })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const plan = await getProspectusVisitsDetails({
            SAP_ID,
            start: selectStartDate,
            end: selectEndDate,
        });
        console.log("gyp", plan?.data);
        setData(plan?.data);
        setCsvData(plan?.data)
        setLoading(true);
    }



    const fileName = `${SAP_ID}-Prospect_Visits`;

    const generateExcel = async (e) => {
        e.preventDefault()
        const visitact = []

        exportExcel(csvData.map((x) => {
            return {
                'SAP ID': x?.SAP_ID,
                'Lead Type': x?.prospectusId?.basicDetail?.leadType,
                "Firm Name": x?.prospectusId?.basicDetail?.firmName,
                'Firm Type': x?.prospectusId?.basicDetail?.natureOfFirm ? x?.prospectusId?.basicDetail?.natureOfFirm : "-",
                "Plan Date": moment(x?.startTime).format('DD-MM-YYYY'),
                "Status": x?.completed ? "Completed" : "Pending",
                'Start Time': moment.utc(x.startTime).format("HH:mm"),
                'End Time': moment.utc(x.endTime).format("HH:mm"),
                // 'Completed': x?.completed,
                "Time Spent (mins)": moment.duration((moment(x.endTime ? x.endTime : "")).diff((moment(x.startTime ? x.startTime : "")))).asMinutes().toFixed(0),
                "Remarks": x?.remark,
            }
        }), fileName)
    }

    console.log("tets", prospectVisit, influencerVisitData, customerVisitData);

    // Build the current tab's rows and empty-state message without changing any data flow.
    let tableRows = null;
    let emptyMessage = "";
    if (prospectVisit) {
        emptyMessage = "No Prospect Visits Available.";
        if (data?.length > 0) {
            tableRows = data.map((d) => (
                <TableRow key={d._id}>
                    <TableCell align="left">{d?.prospectusId?.basicDetail?.firmName}</TableCell>
                    <TableCell align="left">{moment.utc(d?.startTime).format('DD-MM-YYYY')}</TableCell>
                    <TableCell align="left">{d?.prospectusId?.basicDetail?.leadType}</TableCell>
                    <TableCell align="left">{d?.prospectusId?.basicDetail?.natureOfFirm ? d?.prospectusId?.basicDetail?.natureOfFirm : "-"}</TableCell>
                    <TableCell align="left">
                        <Chip
                            size="small"
                            label={d?.completed ? "Completed" : "Pending"}
                            color={getStatusColor(d?.completed)}
                        />
                    </TableCell>
                    <TableCell align="left" style={{ cursor: "pointer" }}>
                        {d.deleted === false ? timeSpent(d?.startTime, d?.endTime) : "NA"}
                    </TableCell>
                    <TableCell align="left">{d?.remark}</TableCell>
                </TableRow>
            ));
        }
    } else if (influencerVisit) {
        emptyMessage = "No Influencer Visits Available.";
        if (influencerVisitData?.length > 0) {
            tableRows = influencerVisitData.map((d) => (
                <TableRow key={d._id}>
                    <TableCell align="left">{d?.influencerId?.name}</TableCell>
                    <TableCell align="left">{moment.utc(d?.startTime).format('DD-MM-YYYY')}</TableCell>
                    <TableCell align="left">{"NA"}</TableCell>
                    <TableCell align="left">{"NA"}</TableCell>
                    <TableCell align="left">
                        <Chip
                            size="small"
                            label={d?.completed ? "Completed" : "Pending"}
                            color={getStatusColor(d?.completed)}
                        />
                    </TableCell>
                    <TableCell align="left" style={{ cursor: "pointer" }}>
                        {d.deleted === false ? timeSpent(d?.startTime, d?.endTime) : "NA"}
                    </TableCell>
                    <TableCell align="left">{d?.remark}</TableCell>
                </TableRow>
            ));
        }
    } else {
        emptyMessage = "No Customer Visits Available.";
        if (customerVisitData?.length > 0) {
            tableRows = customerVisitData.map((d) => (
                <TableRow key={d._id}>
                    <TableCell align="left">{d?.customerId?.businessDetails?.firmName}</TableCell>
                    <TableCell align="left">{moment.utc(d?.startTime).format('DD-MM-YYYY')}</TableCell>
                    <TableCell align="left">{"NA"}</TableCell>
                    <TableCell align="left">{d?.customerId?.businessDetails?.businessType ? d?.customerId?.businessDetails?.businessType : "-"}</TableCell>
                    <TableCell align="left">
                        <Chip
                            size="small"
                            label={d?.completed ? "Completed" : "Pending"}
                            color={getStatusColor(d?.completed)}
                        />
                    </TableCell>
                    <TableCell align="left" style={{ cursor: "pointer" }}>
                        {d.deleted === false ? timeSpent(d?.startTime, d?.endTime) : "NA"}
                    </TableCell>
                    <TableCell align="left">{d?.remark}</TableCell>
                </TableRow>
            ));
        }
    }

    return (
        <>
            <PageHeader
                title="Prospect Visits"
                subtitle="Field visit records for prospects, influencers and customers"
            />

            {/* Filters / actions toolbar */}
            <SectionCard sx={{ mb: 3 }}>
                <Box component="form" onSubmit={handleSubmit}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                type={'date'}
                                fullWidth
                                size="small"
                                label="Start Date"
                                InputLabelProps={{ shrink: true }}
                                onChange={handleChange}
                                value={selectStartDate}
                                name="selectStartDate"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField
                                type={'date'}
                                fullWidth
                                size="small"
                                label="End Date"
                                InputLabelProps={{ shrink: true }}
                                onChange={handleChange}
                                value={selectEndDate}
                                name="selectEndDate"
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Stack direction="row" spacing={1.5}>
                                <Button
                                    variant="contained"
                                    startIcon={<FilterAltOutlinedIcon />}
                                    onClick={handleSubmit}
                                >
                                    Apply
                                </Button>
                                <Button
                                    variant="outlined"
                                    startIcon={<DownloadIcon />}
                                    onClick={generateExcel}
                                >
                                    Download
                                </Button>
                            </Stack>
                        </Grid>
                    </Grid>
                </Box>
            </SectionCard>

            {/* Visit type switcher */}
            <Stack direction="row" spacing={2} flexWrap="wrap" sx={{ mb: 2.5, gap: 1 }}>
                <Button
                    onClick={() => {
                        setProspectVisit(true)
                        setInfluencerVisit(false)
                        setCustomerVisit(false)
                    }}
                    variant={prospectVisit ? "contained" : "outlined"}
                >
                    Prospect Visits
                </Button>
                <Button
                    onClick={() => {
                        setProspectVisit(false)
                        setInfluencerVisit(true)
                        setCustomerVisit(false)
                    }}
                    variant={influencerVisit ? "contained" : "outlined"}
                >
                    Influencer Visits
                </Button>
                <Button
                    onClick={() => {
                        setProspectVisit(false)
                        setInfluencerVisit(false)
                        setCustomerVisit(true)
                    }}
                    variant={customerVisit ? "contained" : "outlined"}
                >
                    Customer Visits
                </Button>
            </Stack>

            {loading ? (
                <TableContainer component={Paper} sx={{ mb: 2.5 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">Firm Name</TableCell>
                                <TableCell align="left">Visit Date</TableCell>
                                <TableCell align="left">Lead Type</TableCell>
                                <TableCell align="left">Firm Nature</TableCell>
                                <TableCell align="left">Status</TableCell>
                                <TableCell align="left">Time Spent</TableCell>
                                <TableCell align="left">Remark</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableRows ? tableRows : (
                                <TableRow>
                                    <TableCell colSpan={7} sx={{ border: 0, p: 0 }}>
                                        <EmptyState title={emptyMessage} />
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
                    <CircularProgress />
                </Box>
            )}

            <Modal open={open} onClose={handleClose}>
                <Box sx={messageStyle}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align='left'>Type</TableCell>
                                <TableCell>Action Taken</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {visitDetails?.length > 0 ? (
                                visitDetails.map((row) => (
                                    <TableRow key={row._id}>
                                        <TableCell align="left" scope="row">{row?.type}</TableCell>
                                        <TableCell align="center" scope="row">{row?.actionTaken}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow key={'1'}>
                                    <TableCell colSpan={3} align="center">
                                        No Visit Action Available.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    <Box sx={{ m: 3, display: 'flex', justifyContent: 'center' }}>
                        <Button variant="contained" onClick={() => setOpen(false)}>Close</Button>
                    </Box>
                </Box>
            </Modal>
        </>
    )
}

export default ProspectusVisits